exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.error{color:#dc3545}.slide-enter-active{animation:slide-in 3s fade forwards}.slide-leave-active{animation:slide-out 3s fade forwards}@keyframes slide-in{0%{transform:translateY(250px)}to{transform:translateY(0)}}@keyframes slide-out{0%{transform:translateY(0)}to{transform:translateY(250px)}}.modal{display:block}.modal-backdrop,.modal-dialog{transition:all .5s ease}.modal-enter .modal-dialog,.modal-leave-active .modal-dialog{opacity:0;transform:translateY(-30%)}.modal-enter .modal-backdrop,.modal-leave-active .modal-backdrop{opacity:0}.modal-backdrop{opacity:.5}.modal-header{height:55px;padding:0 1.6rem;border-bottom:2px solid #eee;font-size:1.2rem;display:flex;align-items:center}.modal-content{border-radius:0}.modal-footer{justify-content:center;padding:0 2px;padding-bottom:5px;flex-wrap:wrap}.modal-footer .btn{margin:0 10px 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49597b0c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChangePassword.vue
// module id = 555
// module chunks = 27